/**
 * [INPUT]: 无
 * [OUTPUT]: 对外提供 AuthContext 与 useAuth
 * [POS]: providers 认证上下文
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */

import { createContext, useContext } from 'react'

export const AuthContext = createContext(null)

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
